import React from "react";
import { Outlet } from "@bcm-dev/bcms-vite";
import MainContentContainer, { MainContentHeader } from "components/shared/containers/MainContentContainer";

import "./styles.css";

/**
 * @function ReplaceMyCardPage
 * @return {React.Component}
 * @exported true
 * @description The main component for ReplaceMyCardPage
 */
export default function ReplaceMyCardPage(props) {
  return (
    <MainContentContainer header={<MainContentHeader text="Replace My Card" />} className="replace-my-card-page">
        <Outlet />
    </MainContentContainer>
  )
}
